import { LitElement, html, css } from "lit-element";
import { customElement, property } from "lit/decorators.js";

@customElement("custom-alert")
export class CustomAlert extends LitElement {
  @property({ type: Boolean }) isOpen = false; // Controls alert visibility
  @property({ type: String }) message = ""; // Message to display in the alert
  @property({ type: String }) title = "Alert"; // Title of the alert

  static styles = css`
    .alert-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      visibility: hidden;
      opacity: 1;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }
    .alert-overlay.is-open {
      visibility: visible;
      opacity: 1;
    }
    .alert-box {
      background: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      max-width: 400px;
      text-align: center;
    }
    .alert-title {
      font-size: 1.5em;
      margin-bottom: 10px;
    }
    .alert-message {
      margin-bottom: 20px;
    }
    .alert-buttons {
      display: flex;
      justify-content: center;
      gap: 10px;
    }
    .alert-button {
      padding: 10px 20px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 1em;
    }
    .alert-button.confirm {
      background-color: #4caf50;
      color: white;
    }
    .alert-button.cancel {
      background-color: #f44336;
      color: white;
    }
  `;

  // Method to close the alert
  closeAlert() {
    this.isOpen = false;
    const event = new CustomEvent("alert-closed", {
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  // Method to handle confirm action
  confirmAlert() {
    const event = new CustomEvent("alert-confirmed", {
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
    this.closeAlert();
  }

  openAlert(title, message) {
    this.isOpen = true;
    this.title = title;
    this.message = message;
  }

  protected createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="alert-overlay ${this.isOpen ? "is-open" : ""}">
        <div class="alert-box">
          <div class="alert-title">${this.title}</div>
          <div class="alert-message">${this.message}</div>
          <div class="alert-buttons">
            <button class="alert-button confirm" @click="${this.confirmAlert}">
              Confirm
            </button>
            <button class="alert-button cancel" @click="${this.closeAlert}">
              Cancel
            </button>
          </div>
        </div>
      </div>
    `;
  }
}
